module.exports = __webpack_public_path__ + "img/meson_network.4084eeb9.png";